<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Course Management</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage courses across programs.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} courses found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        @if (showaddbutton) {
          <a routerLink="/add-course" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>add</mat-icon>
            Add Course
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.CourseKeyword" placeholder="Course name" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Program</mat-label>
            <mat-select placeholder="All Programs" name="filterprogram" [(ngModel)]="queryFilter.CourseProgram">
              <mat-option value="0">All Programs</mat-option>
              @for (cp of coursePrograms; track cp) {
                <mat-option [value]="cp.id">{{ cp.programName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Tag</mat-label>
            <mat-select placeholder="All Tags" name="filtercoursetag" [(ngModel)]="queryFilter.Tag">
              <mat-option value="0">All Tags</mat-option>
              @for (tag of tags; track tag) {
                <mat-option [value]="tag.id">{{ tag.tagName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filtercoursestatus" [(ngModel)]="queryFilter.CourseStatus">
              <mat-option value="0">All Statuses</mat-option>
              @for (cs of courseStatus; track cs) {
                <mat-option [value]="cs.key">{{ cs.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="courseTable; context: { data: courseList, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="Course list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #courseTable let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Course Name</th>
      <td mat-cell *matCellDef="let course">
        <a [routerLink]="['/view-course', course.id]" class="user-mgmt-page__user-link">{{ course.courseName }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let course">{{ course.courseId }}</td>
    </ng-container>

    <ng-container matColumnDef="program">
      <th mat-header-cell *matHeaderCellDef>Programs</th>
      <td mat-cell *matCellDef="let course">
        @if (course.programs?.length) {
          <ul class="user-mgmt-page__chip-list">
            @for (program of course.programs; track program) {
              <li>
                <span class="user-mgmt-page__chip user-mgmt-page__chip--program">{{ program }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="user-mgmt-page__empty-text">—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="enrollment">
      <th mat-header-cell *matHeaderCellDef>Total Enrollment</th>
      <td mat-cell *matCellDef="let course">{{ course.enrollment }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let course">
        <app-status-bubble [status]="course.status"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
